module.exports = __webpack_public_path__ + "static/media/guide-policy.e968f319.svg";